export default {
	entityTypeRestaurant: 0,
	entityTypeCategory: 1,
	mobileType: 2,
	webType: 1,
	seoColumns: [
		{ key: 'id', label: 'Id', initialSort: true, initialSortDirection: 'asc' },
		{ key: 'entityType', label: 'Type' },
		{ key: 'metaTitle', label: 'Title' },
		{ key: 'metaDescription', label: 'Description' },
		{ key: 'metaKeyWords', label: 'KeyWords' },
	],
	categoryColumns: [
		{ key: 'categoryName', label: 'Name' },
		{ key: 'description', label: 'Description' },
		{ key: 'city', label: 'City' },
		{ key: 'businessType', label: 'BusinessType' },
		{ key: 'type', label: 'Type' },
		{ key: 'orderNo', label: 'Priority', initialSort: true, initialSortDirection: 'asc' },
		{ key: 'startDate', label: 'StartDate' },
		{ key: 'endDate', label: 'EndDate' },
		{ key: 'status', label: 'Status' },
	],
};
